export const safraErrors = {
  BANK_AUTH: 7,
  WITHDRAW_AUTH: 9,
  NO_FGTS_ACCOUNT: 8,
  OUT_OF_SERVICE: 406,
  OUT_OF_DATE: 10,
  PROPOSAL_IN_PROGRESS: 14,
  NO_BALANCE: 12,
};
